<template>
  <side-base>
    <div class="swrap">
      <div class="smain">
        <van-cell
          v-if="config.enableCampusFilter"
          title="校区"
          is-link
          :value-class="['van-ellipsis', { selected: params.campusList.length > 0 }]"
          :value="campusText || '请选择'"
          @click="chooseCampus"
        />

        <div class="three-a-row" v-if="config.enableChargeType">
          <div class="nav-title">计费方式</div>
          <div class="nav-div">
            <div class="nav-box" v-for="item of chargeTypeArr" :key="item.id">
              <div
                class="item-nav"
                :class="{
                  active: params.chargeTypeList.indexOf(item.id) != -1,
                }"
                @click="triggerChargeType(item)"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>

        <div class="three-a-row" v-if="config.enableHaltSale">
          <div class="nav-title">状态</div>
          <div class="nav-div">
            <div class="nav-box" v-for="item of haltSaleArr" :key="item.id">
              <div
                class="item-nav"
                :class="{
                  active: params.haltSaleList.indexOf(item.id) != -1,
                }"
                @click="triggerHaltSale(item)"
              >
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>

        <template v-if="config.enableDimension">
          <van-cell
            v-for="item in dimensArr"
            :key="item.id"
            :title="item.dimensionName"
            is-link
            :value-class="['van-ellipsis', { selected: item.choose_list.length > 0 }]"
            :value="getChooseDimensionText(item) || '请选择'"
            @click="chooseDimension(item)"
          />
        </template>
      </div>
      <side-foot cancelText="重置" @cancel="reset" @confirm="confirm(getRet())" />
    </div>
  </side-base>
</template>

<script>
import sideMixinBase from '@x3/js/side/0_mixin/mixin-base.js';

export default {
  name: '',
  components: {},
  mixins: [sideMixinBase],
  data() {
    return {
      callParams: {},
      params: {},
      config: {
        // 校区筛选是否开启
        enableCampusFilter: true,
        // 计费方式筛选是否开启
        enableChargeType: true,
        // 启停售筛选是否开启
        enableHaltSale: true,
        // 课程属性筛选
        enableDimension: true,
      },

      dimensArr: [],

      haltSaleArr: [
        {
          id: 0,
          text: '启用',
        },
        {
          id: 1,
          text: '停售',
        },
      ],
    };
  },
  computed: {
    ...Vuex.mapState(['lessonUnit']),
    chargeTypeArr: function () {
      return [
        {
          id: 1,
          text: `按${this.lessonUnit}`,
        },
        {
          id: 2,
          text: '按天',
        },
      ];
    },
    campusText: function () {
      let cps = this.params.campusList,
        text = '';
      if (cps.length == 1) {
        text = cps[0].name;
      } else if (cps.length > 1) {
        text = `${cps.length}个校区`;
      }
      return text;
    },
    // 根据配置项决定默认参数
    defaultParams() {
      let obj = {
        campusIds: [],
        campusList: [],
        chargeTypeList: [],
        haltSaleList: [],
        dimensionDetailIdList: [],
      };
      let cPms = this.callParams;
      let conf = this.config;

      if (!conf.enableCampusFilter && cPms.campusIds) {
        obj.campusIds = cPms.campusIds;
        obj.campusList = cPms.campusList;
      }
      if (!conf.enableChargeType && cPms.chargeTypeList) {
        obj.chargeTypeList = cPms.chargeTypeList;
      }
      if (!conf.enableHaltSale && cPms.haltSaleList) {
        obj.haltSaleList = cPms.haltSaleList;
      }
      if (!conf.enableDimension && cPms.dimensionDetailIdList) {
        obj.dimensionDetailIdList = cPms.dimensionDetailIdList;
      }
      return obj;
    },
  },
  methods: {
    init() {
      let opts = this.$vxRoute.meta.options || {};

      if (opts.config) {
        let config = JSON.parse(JSON.stringify(opts.config));
        this.config = Object.assign(this.config, config);
      }
      if (opts.params) {
        this.callParams = JSON.parse(JSON.stringify(opts.params));
      }
      this.params = Object.assign({}, this.defaultParams, this.callParams);

      if (opts.dimensionList) {
        this.dimensArr = JSON.parse(JSON.stringify(opts.dimensionList));
      } else {
        this.getDimension();
      }
    },
    async getDimension() {
      let ret = await this.$api.basePriceDimensionDetailList({
        page: {
          pageNum: 1,
          pageSize: 9999,
        },
      });
      console.log(ret);

      this.dimensArr = ret.data.map(item => {
        return {
          ...item,
          choose_ids: [],
          choose_list: [],
        };
      });
    },
    // 选择属性
    async chooseDimension(dimension) {
      let res = await app.x3.side.xsCourseDimension({
        ids: dimension.choose_ids,
        list: dimension.choose_list,
        listAll: dimension.basePriceDimensionDetailList,
        config: {
          radio: true
        }
      });
      console.log(res);
      dimension.choose_ids = res ? [res.id] : [];
      dimension.choose_list = res? [res] : [];
    },
    getChooseDimensionText(dimension) {
      let cps = dimension.choose_list,
        text = '';
      if (cps.length == 1) {
        text = cps[0].dimensionValue;
      } else if (cps.length > 1) {
        text = `${cps.length}个属性`;
      }
      return text;
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
      });

      // 如果选中的校区发生变化，还需要清除已选的老师
      let oIdsStr = this.params.campusIds.join(),
        nOdsStr = res.ids.join();
      if (oIdsStr != nOdsStr) {
        this.params.campusIds = res.ids;
        this.params.campusList = res.list;

        this.params.teacherIds = [];
        this.params.teacherList = [];
      }
    },
    triggerChargeType(item) {
      let list = this.params.chargeTypeList,
        idx = list.indexOf(item.id);
      idx == -1 ? list.push(item.id) : list.splice(idx, 1);
    },
    triggerHaltSale(item) {
      let list = this.params.haltSaleList,
        idx = list.indexOf(item.id);
      idx == -1 ? list.push(item.id) : list.splice(idx, 1);
    },

    // 重置
    reset() {
      this.params = JSON.parse(JSON.stringify(this.defaultParams));
      this.dimensArr.forEach(item => {
        item.choose_ids = [];
        item.choose_list = [];
      });
    },
    async getRet() {
      this.params.dimensionDetailIdList = [];
      this.dimensArr.forEach(item => {
        this.params.dimensionDetailIdList.push(...item.choose_ids);
      });
      console.log(this.params.dimensionDetailIdList);
      return JSON.parse(
        JSON.stringify({
          params: this.params,
          dimensionList: this.dimensArr,
        })
      );
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  .smain {
    flex: 1;
    overflow: auto;
  }
}
</style>